// extracted by mini-css-extract-plugin
export default {"root":"style_root__1cSPm","label":"style_label__jvuz8","value":"style_value__DgZU_"};